import csiCard, { CardSpecs } from "csi/card/_base";
import ContextConstructor from "csi/def/Context";
import csiHeading from "csi/heading/_base";
import { getImageSrc } from "csi/model/image";
import WorkingCache from "csi/state/WorkingCache";
import { ATTR_TYPE, C8Node, cnl, ICache } from "csi/typings";

/** get SlimCard node attributes as String
 * @param url node url
 * @param cache cache instance
 * @param separator string to join attributes
 */
export function getSlimCardAttrsAsString(url: cnl, cache: ICache, separator: string = ""): string {
	const ctx = new ContextConstructor(null, cache, url);
	const specs = csiCard.getAttributeCardSlimSpecs(ctx.getNode()?.$Type);
	const attrSpecs = specs?.attributeSpecs;
	const attributes = [];
	for (let i = 0; i < attrSpecs.length; i++) {
		attributes.push(csiHeading.toText(ctx, attrSpecs[i].heading));
	}
	return attributes.join(separator);
}

export class SlimCardStore {
	private readonly cache: ICache = new WorkingCache();

	private _imageSrc: string = null;

	/** attribute card specs */
	private specs: CardSpecs;

	/** node URL to get the card specs attribute */
	readonly urlNode: cnl;

	/** image path in case it is not defined on Node Type Name */
	readonly imagePath?: string = null;

	constructor(urlNode: cnl, cache: ICache, imageSrc?: string, imagePath?: string) {
		this.urlNode = urlNode;
		this.cache = cache;
		this.specs = csiCard.getAttributeCardSlimSpecs(this.node[ATTR_TYPE]);
		this.imagePath = imagePath || this.specs.imageSpec.heading.m_path;
		this._imageSrc = imageSrc;
	}
	
	/** join the attribute in a combined string */
	get attributeCombination(): string {
		return getSlimCardAttrsAsString(this.urlNode, this.cache, " | ");
	}

	/** get image src including Image Container Path */
	get imageSrc(): string {
		const { _imageSrc } = this;
		if (_imageSrc) {
			return _imageSrc;
		} 
		
		const { cache, imagePath, node, urlNode } = this;
		let imageContainer = node;
		if (imagePath) {
			imageContainer = cache.getPathNode(urlNode, imagePath);
			if (!imageContainer) {
				return getImageSrc(node, imagePath);
			}
		}
		return getImageSrc(imageContainer);
	}

	/** get C8Node instance from cache */
	get node(): C8Node {
		return this.cache.get(this.urlNode);
	}
}
